"use client"

import { RegistrationForm } from "@workspace/ui/components/own/register-form"
import RegisterForm from "@workspace/ui/components/own/RegisterForm"

import TestForm from "@workspace/ui/components/own/FormFrame/forms/TestForm"

export default function RegisterPage() {
    return (
        <main className="min-h-screen p-8">
            {/* <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 items-start"> */}
            <div className="w-full max-w-6xl mx-auto px-6">

                <TestForm />


                {/* <RegisterForm /> */}

            </div>
        </main>
    )
}
